module.exports = __webpack_public_path__ + "static/media/iib.926a26d7.jpeg";